const binding = { modules: {}, dataActions: {} };

    (binding.modules['meriton-mpsw'] = {
        c: () => require('partner/themes/meriton-mpsw/meriton-mpsw.tsx'),
        $type: 'themeModule',
        da: [],
        definitionExtensions: ['active-image','b2b-requests-status','business-organization-list','buybox','cart-icon','content-block','header','image-list','navigation-menu','order-details','order-template-list','promo-banner','quickview','reviews-list','search','sign-in','store-selector','text-block','write-review'],
        iNM: false,
        ns: '__local__',
        n: 'meriton-mpsw',
        p: '__local__',
        
        pdp: '',
        
        themeSettings: 'meriton-mpsw.theme.settings.json',
        md: 'src/themes/meriton-mpsw'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };